import { ValueObject } from '@nx-smartmonkey/shared/domain';

export type ProjectCustomerWhatsAppType =
  | `route_started`
  | `stop_created`
  | `stop_approaching`
  | `stop_completed`
  | `stop_canceled`
  | `pickup_created`
  | `pickup_approaching`
  | `pickup_completed`
  | `pickup_canceled`;

export interface ProjectCustomerWhatsAppItemProps {
  subaccount_id?: string;
  from?: string;
  enabled: boolean;
  template_id?: string;
  replacement_values?: Record<string, string>;
  updated_at?: Date;
}

export class ProjectCustomerWhatsAppItem extends ValueObject<ProjectCustomerWhatsAppItemProps> {
  get subaccount_id(): string | undefined {
    return this.props.subaccount_id;
  }

  get from(): string | undefined {
    return this.props.from;
  }
  get enabled(): boolean {
    return this.props.enabled;
  }
  get template_id(): string | undefined {
    return this.props.template_id;
  }
  get updated_at(): Date | undefined {
    return this.props.updated_at;
  }
  get replacement_values(): Record<string, string> | undefined {
    return this.props.replacement_values;
  }
  private constructor(props: ProjectCustomerWhatsAppItemProps) {
    super(props);
  }
  static create(props: ProjectCustomerWhatsAppItemProps): ProjectCustomerWhatsAppItem {
    return new ProjectCustomerWhatsAppItem(props);
  }
}
